import { Component } from '@angular/core';
import { ATableMenuTab } from './mactable.menu.tab';

@Component({
    selector: 'mactable-fix-menu-tab',
    templateUrl: './fix.menu.tab.html'
})
export class MacTableFixMenuTab extends ATableMenuTab {
}
